import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import useHashParam from 'use-hash-param';

import { AppLayoutContainer } from '../components/app/AppLayout';
import { Loader } from '../components/design-system/Loader';
import { CheckoutConfirmationPageContainer } from '../components/checkout/CheckoutConfirmationPage';
import { Config } from '../services/Config';
import { useRouter, useSiteRoutes } from '../services/Navigation';

export const Route = createFileRoute('/checkout-confirmation')({
  component: CheckoutConfirmationRoute,
});

function CheckoutConfirmationRoute() {
  const router = useRouter();
  const { routes } = useSiteRoutes();
  const [subscriptionId] = useHashParam('subscriptionId', '');

  React.useEffect(() => {
    if (!subscriptionId) {
      router.push(routes.checkout.path);
    }
  }, [router, routes.checkout.path, subscriptionId]);

  return (
    <AppLayoutContainer
      helpAndSupportUrl={Config.APPLICATION_GENERAL_HELPARTICLE_URL}
      siteName={Config.APPLICATION_SHORT_DISPLAY_NAME}
    >
      {!subscriptionId && <Loader label="Redirecting..." />}

      {!!subscriptionId && (
        <CheckoutConfirmationPageContainer
          subscriptionId={subscriptionId}
          onContinueClick={(url) => {
            window.location.href = url;
          }}
        />
      )}
    </AppLayoutContainer>
  );
}
